import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startWorkFlow } from "../../store/workFlow/actions";
export var useStartWokFlow = function (trigger, workFlowId, onResetTrigger) {
    if (trigger === void 0) { trigger = false; }
    if (workFlowId === void 0) { workFlowId = ""; }
    var dispatch = useDispatch();
    var validWorkFlowId = (workFlowId !== null && workFlowId !== void 0 ? workFlowId : "").trim();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            loadingStartWorkFlow: state.WorkFlow.loadingStartWorkFlow,
            responseStartWorkFlow: (_a = state.WorkFlow.responseStartWorkFlow) === null || _a === void 0 ? void 0 : _a.data,
            errorStartWorkflow: state.WorkFlow.errorStartWorkflow,
        });
    }), loadingStartWorkFlow = _a.loadingStartWorkFlow, responseStartWorkFlow = _a.responseStartWorkFlow, errorStartWorkflow = _a.errorStartWorkflow;
    useEffect(function () {
        if (!trigger || !validWorkFlowId)
            return;
        dispatch(startWorkFlow({
            id: workFlowId,
        }));
        if (onResetTrigger)
            onResetTrigger();
    }, [trigger, dispatch, workFlowId]);
    return {
        loadingStartWorkFlow: loadingStartWorkFlow,
        responseStartWorkFlow: responseStartWorkFlow,
        errorStartWorkflow: errorStartWorkflow,
    };
};
